import { memo } from 'react';
import Images from 'src/App/Images';
import { ReverseCommandTypes } from 'src/App/Types/command.enums';

export function RenderCommandTypeImgs({ type }) {
	const MemoisedIcon = memo(
		function PreRenderIcons({ type }: { type: any }) {
			if (ReverseCommandTypes[type] == 'Color') {
				return <Images.CommandColor />;
			} else if (ReverseCommandTypes[type] == 'Animation') {
				return <Images.CommandAnimation />;
			} else if (ReverseCommandTypes[type] == 'Command') {
				return <Images.CommandColor />;
			} else if (ReverseCommandTypes[type] == 'Interactive') {
				return <Images.CommandInteractive />;
			} else if (ReverseCommandTypes[type] == 'Reaction') {
				return <Images.CommandReaction />;
			} else if (ReverseCommandTypes[type] == 'Scenes') {
				return <Images.CommandScenes />;
			} else if (ReverseCommandTypes[type] == 'Buildups') {
				return <Images.CommandBuildups />;
			} else if (ReverseCommandTypes[type] == 'Themes') {
				return <Images.CommandThemes />;
			} else {
				return <Images.CommandColor />;
			}
		},
		() => true,
	);

	return <MemoisedIcon type={type} />;
}
